// Bespoke rather than Orion's currencyToNumber: these fields are whole-number scores/indices,
// not currency — we want integers only and out-of-range left unscored (never clamped/rounded).
// German-typed integer: a plain run of digits, or dot-grouped thousands where every dot group is
// exactly 3 digits. This rejects dot-as-decimal ("12.5") rather than collapsing it to 125.
export const parseIntDe = (
  raw: string | null | undefined,
): number | undefined => {
  if (raw === null || raw === undefined) return undefined;
  const trimmed = String(raw).trim().replace(/\s/g, '');
  if (!/^(\d+|\d{1,3}(\.\d{3})+)$/.test(trimmed)) return undefined;
  const parsed = parseInt(trimmed.replace(/\./g, ''), 10);
  return Number.isFinite(parsed) ? parsed : undefined;
};
